import { render, staticRenderFns } from "./SystemIndexView.vue?vue&type=template&id=137043da&scoped=true&"
import script from "./SystemIndexView.vue?vue&type=script&lang=js&"
export * from "./SystemIndexView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137043da",
  null
  
)

export default component.exports